import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  bugReportsPageWrapper: {},
  bugReportsListContainer: {
    marginTop: theme.spacing(0.5),
    '& > div + div': {
      marginTop: theme.spacing(0.5),
    },
  },
}));
